import { BaseService } from "./BaseService";

export const EmendaEstadualService = {
    async index(filter = null) {
        try {
            return await BaseService.fetchResponseFromAPIPost('emendas-estaduais/search', filter);
        } catch (error) {
            console.error('Ocorreu um erro ao listar todas emendas estaduais:', error);
            return false;
        }
    },
    async show(id) {
        try {
            return await BaseService.fetchResponseFromAPIGet(`emendas-estaduais/${id}`);
        } catch (error) {
            console.error('Ocorreu um erro durante a busca da emenda estadual:', error);
            return false;
        }
    },
    async autocomplete(field, search = '') {
        try {
            const params = search ? `?search=${encodeURIComponent(search)}` : '';
            return await BaseService.fetchResponseFromAPIGet(`emendas-estaduais/autocomplete/${field}${params}`);
        } catch (error) {
            console.error('Ocorreu um erro ao buscar opções de autocomplete:', error);
            return false;
        }
    },
    async getUnidadesOptions(search = '') {
        try {
            const params = search ? `?search=${encodeURIComponent(search)}` : '';
            return await BaseService.fetchResponseFromAPIGet(`emendas-estaduais/options/unidades${params}`);
        } catch (error) {
            console.error('Ocorreu um erro ao buscar opções de unidades:', error);
            return false;
        }
    },
    async getCidadesOptions(search = '') {
        try {
            const params = search ? `?search=${encodeURIComponent(search)}` : '';
            return await BaseService.fetchResponseFromAPIGet(`emendas-estaduais/options/cidades${params}`);
        } catch (error) {
            console.error('Ocorreu um erro ao buscar opções de cidades:', error);
            return false;
        }
    },
    async getAnosOptions() {
        try {
            return await BaseService.fetchResponseFromAPIGet('emendas-estaduais/options/anos');
        } catch (error) {
            console.error('Ocorreu um erro ao buscar opções de anos:', error);
            return false;
        }
    },
    async getGerenciasOptions() {
        try {
            return await BaseService.fetchResponseFromAPIGet('emendas-estaduais/options/gerencias');
        } catch (error) {
            console.error('Ocorreu um erro ao buscar opções de gerências:', error);
            return false;
        }
    },
}

